var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7533 3.59077C27.5948 3.02521 27.2859 2.51318 26.8597 2.10911C26.4213 1.69261 25.8841 1.39468 25.2987 1.24344C23.1077 0.665941 14.3297 0.665942 14.3297 0.665942C10.6702 0.624306 7.01166 0.807429 3.37466 1.21427C2.78921 1.37669 2.25298 1.68128 1.81366 2.10094C1.38199 2.51627 1.06932 3.02844 0.905991 3.58961C0.513633 5.70331 0.322998 7.84951 0.336658 9.99927C0.322658 12.1471 0.512824 14.2926 0.905991 16.4089C1.06582 16.9678 1.37732 17.4776 1.81016 17.8894C2.24299 18.3013 2.78199 18.5988 3.37466 18.7563C5.59482 19.3326 14.3297 19.3326 14.3297 19.3326C17.9938 19.3743 21.657 19.1912 25.2987 18.7843C25.8841 18.633 26.4213 18.3351 26.8597 17.9186C27.2858 17.5146 27.5943 17.0025 27.7522 16.4369C28.1548 14.3241 28.3505 12.177 28.3367 10.0261C28.3669 7.86615 28.1714 5.70893 27.7533 3.58961V3.59077ZM11.539 13.9939V6.00577L18.8423 10.0004L11.539 13.9939Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialYoutube);
export default __webpack_public_path__ + "static/media/Social-Youtube.59e22ed429a909b444117809a6a7788c.svg";
export { ForwardRef as ReactComponent };